import { WelcomeAttaches } from 'reactApp/components/WelcomeAttaches/WelcomeAttaches';
import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';

import WelcomeDialogConnected from './WelcomeDialog';

export const renderWelcomeDialogHelper = renderModalDialog(WelcomeDialogConnected, 'WelcomeDialog');
export const renderWelcomeAttachesDialogHelper = renderModalDialog(WelcomeAttaches, 'WelcomeAttaches');

export default {
    renderWelcomeDialogHelper,
    renderWelcomeAttachesDialogHelper,
};
